import { useEffect, useState } from "react";
import { TOKEN_KEY } from "../../components/providers/authProvider";
import { socketConnect } from "../socket";

export const useReloadSocket = () => {
  const [reloadSocket, setReloadSocket] = useState(
    localStorage.getItem("reloadSocket")
  );

  const [socketInstance, setSocketInstance] = useState(
    socketConnect(localStorage.getItem(TOKEN_KEY) ?? undefined).socket
  );

  // Listen for localStorage changes to reloadSocket
  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === "reloadSocket") {
        setReloadSocket(e.newValue);
      }
    };
    window.addEventListener("storage", handleStorageChange);

    // Also listen for custom event for same-tab updates
    const handleCustomStorageChange = () => {
      setReloadSocket(localStorage.getItem("reloadSocket"));
    };
    window.addEventListener("reloadSocket", handleCustomStorageChange as any);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener(
        "reloadSocket",
        handleCustomStorageChange as any
      );
    };
  }, []);

  // Reconnect socket when reloadSocket changes
  useEffect(() => {
    const { socket } = socketConnect(
      localStorage.getItem(TOKEN_KEY) ?? undefined
    );
    setSocketInstance(socket);
  }, [reloadSocket]);

  return socketInstance;
};


